export class GetLocations {
  static readonly type = "[Location] Get locations";
}
